var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailExspressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.105.513c-.092-.025-.194-.014-.283.038L.69 7.606c-.09.053-.15.138-.176.232-.025.095-.015.2.038.292l4.116 7.18c.052.09.135.152.228.177.092.025.194.014.283-.038L17.31 8.394c.09-.053.15-.138.176-.232.025-.095.015-.2-.038-.292L13.105.513z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M13.03.904L9.879 8.421M.882 7.663L9.818 8.421",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M4.909 15.579L8.936 8.49M10.227 7.579L17.591 8",
    transform: "translate(0 1)"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M17.419.625L24 .625M21.07 8.201L28.548 8.201",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M19.934 5.24L24.84 5.24",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M18.26 11.2L23.16 11.2M14.062 13.2L19.871 13.2",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M18.257 3.24L23.163 3.24",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9.871 15.601L17.355 15.601",
    transform: "translate(0 1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailExspressIcon);
export default __webpack_public_path__ + "static/media/email-exspress-icon.5a7b3a959b8ac450d31ce41ddde401e8.svg";
export { ForwardRef as ReactComponent };